import { render, staticRenderFns } from "./KnowledgeDetail.vue?vue&type=template&id=a80c26a4&scoped=true"
import script from "./KnowledgeDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeDetail.vue?vue&type=style&index=0&id=a80c26a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80c26a4",
  null
  
)

export default component.exports